import { render, staticRenderFns } from "./Finish.vue?vue&type=template&id=55310084&scoped=true"
import script from "./Finish.ts?vue&type=script&lang=ts"
export * from "./Finish.ts?vue&type=script&lang=ts"
import style0 from "./Finish.vue?vue&type=style&index=0&id=55310084&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55310084",
  null
  
)

export default component.exports